import React, { useState } from 'react';
import { EditorLabel } from '../EditorLabel';
import { IEditorProps } from '../Editor';
import { PickStringFilterField } from 'components/inputs/data-filters/PickStringFilterField';
import { useScopeHandlers } from './hooks/useScopeHandlers';
import { PickStringFilterValue } from '@decisions/server/DecisionsFramework/Design/Page/Filters';

// import './PickStringFilterEditor.less'

export interface IPickStringFilterEditorProps extends IEditorProps {}

// const getClassName = () => classNames('dpc-numeric-range-filter-editor');

// declaring locally because something is up with TS generation :(

/**
 * Property Editor wrapper for ComboFilterField
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function PickStringFilterEditor({ child, path, onChange, hideInputLabel }: IPickStringFilterEditorProps) {
  const [value, setValue] = useState(child.Value.OutputValue as PickStringFilterValue);

  const onValueChange = (newValue: PickStringFilterValue) => {
    onChange(newValue, path);
    setValue({ ...value, ...newValue });
  };

  const { personalization } = useScopeHandlers({ value, path, setValue, onChange });
  const fieldId = path.join(',');
  return (
    <EditorLabel editor={child} path={path} hideInputLabel={hideInputLabel} doNotWrap={true} htmlFor={fieldId}>
      <PickStringFilterField onChange={onValueChange} personalization={personalization} value={value} id={fieldId} />
    </EditorLabel>
  );
}
